module.exports = __webpack_public_path__ + "static/media/mbr-1920x1280.682164f9.jpg";